import React, { useState } from 'react';
import styled from 'styled-components';
import { FaSearch, FaShoppingCart, FaStar } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';

// Extended product data with more products
const products = [
  {
    id: 1,
    name: "Whey Protein Isolate",
    price: "₹2,999",
    originalPrice: "₹3,499",
    image: "https://images.unsplash.com/photo-1593095948071-474c5cc2989d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80",
    category: "Protein",
    rating: 4.8,
    reviews: 245,
    description: "Premium whey protein isolate for muscle building and recovery. 25g protein per serving with essential amino acids.",
    benefits: ["Fast absorption", "Muscle recovery", "Low lactose", "25g protein per serving"]
  },
  {
    id: 2,
    name: "Mass Gainer Pro",
    price: "₹3,299",
    originalPrice: "₹3,799",
    image: "https://i.pinimg.com/736x/09/9b/35/099b357445a789df528c1e5194bea820.jpg",
    category: "Weight Gainer",
    rating: 4.6,
    reviews: 189,
    description: "High-calorie mass gainer for serious weight and muscle gain. Perfect for hard gainers and athletes.",
    benefits: ["1200+ calories", "50g protein", "Complex carbs", "Weight gain support"]
  },
  {
    id: 3,
    name: "BCAA Energy Drink",
    price: "₹1,799",
    originalPrice: "₹2,199",
    image: "https://i.pinimg.com/736x/86/c7/cc/86c7cc32d37cfc19a9828938549771a3.jpg",
    category: "Amino Acids",
    rating: 4.7,
    reviews: 156,
    description: "Essential amino acids for energy and muscle recovery during intense training sessions.",
    benefits: ["Muscle recovery", "Energy boost", "Hydration", "Anti-fatigue"]
  },
  {
    id: 4,
    name: "Pre-Workout Booster",
    price: "₹2,199",
    originalPrice: "₹2,599",
    image: "https://i.pinimg.com/736x/35/f8/db/35f8db49c88b0128b1fb405303bb1a6b.jpg",
    category: "Pre-Workout",
    rating: 4.9,
    reviews: 312,
    description: "Explosive energy and focus for intense workouts. Contains caffeine, beta-alanine, and creatine.",
    benefits: ["Intense energy", "Mental focus", "Muscle pumps", "Enhanced performance"]
  },
  {
    id: 5,
    name: "Creatine Monohydrate",
    price: "₹1,499",
    originalPrice: "₹1,899",
    image: "https://images.unsplash.com/photo-1584308666744-24d5c474f2ae?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80",
    category: "Strength",
    rating: 4.8,
    reviews: 278,
    description: "Pure creatine monohydrate for strength and power. Micronized for better absorption.",
    benefits: ["Increased strength", "Power output", "Muscle volume", "Quick absorption"]
  },
  {
    id: 6,
    name: "Multivitamin Complex",
    price: "₹999",
    originalPrice: "₹1,299",
    image: "https://i.pinimg.com/736x/98/df/9a/98df9a91c497b3c50ce85c7e1e24db64.jpg",
    category: "Vitamins",
    rating: 4.5,
    reviews: 198,
    description: "Complete daily nutrition support for active lifestyles. 25 essential vitamins and minerals.",
    benefits: ["Daily nutrition", "Immune support", "Energy metabolism", "25 vitamins & minerals"]
  },
  {
    id: 7,
    name: "L-Glutamine Powder",
    price: "₹1,699",
    originalPrice: "₹2,099",
    image: "https://i.pinimg.com/736x/e2/b4/7e/e2b47efce408c2454de573b19b7de2dc.jpg",
    category: "Recovery",
    rating: 4.6,
    reviews: 134,
    description: "Premium glutamine for faster muscle recovery and immune support during intense training.",
    benefits: ["Muscle recovery", "Immune support", "Reduced soreness", "Post-workout healing"]
  },
  {
    id: 8,
    name: "Fish Oil Omega-3",
    price: "₹1,299",
    originalPrice: "₹1,599",
    image: "https://images.unsplash.com/photo-1628771065518-0d82f1938462?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80",
    category: "Health",
    rating: 4.7,
    reviews: 167,
    description: "High-quality omega-3 fatty acids for heart and brain health. Triple strength formula.",
    benefits: ["Heart health", "Brain function", "Joint support", "Anti-inflammatory"]
  },
  {
    id: 9,
    name: "Casein Protein",
    price: "₹2,799",
    originalPrice: "₹3,199",
    image: "https://images.unsplash.com/photo-1593095948071-474c5cc2989d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80",
    category: "Protein",
    rating: 4.7,
    reviews: 203,
    description: "Slow-digesting protein perfect for nighttime recovery. Keeps muscles fed for hours.",
    benefits: ["Slow release", "Night recovery", "Muscle preservation", "24g protein per serving"]
  },
  {
    id: 10,
    name: "Fat Burner Capsules",
    price: "₹2,499",
    originalPrice: "₹2,899",
    image: "https://i.pinimg.com/736x/35/f8/db/35f8db49c88b0128b1fb405303bb1a6b.jpg",
    category: "Weight Loss",
    rating: 4.4,
    reviews: 178,
    description: "Advanced fat burning formula with green tea extract, L-carnitine, and caffeine.",
    benefits: ["Fat burning", "Metabolism boost", "Energy increase", "Appetite control"]
  },
  {
    id: 11,
    name: "ZMA Complex",
    price: "₹1,899",
    originalPrice: "₹2,299",
    image: "https://i.pinimg.com/736x/98/df/9a/98df9a91c497b3c50ce85c7e1e24db64.jpg",
    category: "Recovery",
    rating: 4.6,
    reviews: 142,
    description: "Zinc, Magnesium, and Vitamin B6 complex for better sleep and recovery.",
    benefits: ["Better sleep", "Muscle recovery", "Hormone support", "Zinc & Magnesium"]
  },
  {
    id: 12,
    name: "Nitric Oxide Booster",
    price: "₹2,299",
    originalPrice: "₹2,699",
    image: "https://i.pinimg.com/736x/35/f8/db/35f8db49c88b0128b1fb405303bb1a6b.jpg",
    category: "Pre-Workout",
    rating: 4.8,
    reviews: 256,
    description: "Advanced nitric oxide formula for incredible muscle pumps and vascularity.",
    benefits: ["Muscle pumps", "Vascularity", "Blood flow", "Endurance boost"]
  }
];

const categories = ["All", "Protein", "Weight Gainer", "Amino Acids", "Pre-Workout", "Strength", "Vitamins", "Recovery", "Health", "Weight Loss"];

const PageContainer = styled.div`
  min-height: 100vh;
  background: linear-gradient(135deg, #0a0a0a 0%, #1a1a1a 100%);
  color: #fff;
`;

const MainContent = styled.div`
  padding: 120px 20px 60px;
  max-width: 1400px;
  margin: 0 auto;
  
  @media (max-width: 768px) {
    padding: 100px 15px 40px;
  }
`;

const Header = styled.div`
  text-align: center;
  margin-bottom: 60px;
  
  @media (max-width: 768px) {
    margin-bottom: 40px;
  }
`;

const Title = styled.h1`
  font-size: 4rem;
  color: #fff;
  font-weight: 700;
  margin-bottom: 20px;
  
  @media (max-width: 768px) {
    font-size: 2.5rem;
  }
  
  @media (max-width: 480px) {
    font-size: 2rem;
  }
`;

const Subtitle = styled.p`
  font-size: 1.3rem;
  color: #ccc;
  margin-bottom: 40px;
  line-height: 1.6;
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
  
  @media (max-width: 768px) {
    font-size: 1.1rem;
  }
`;

const FilterSection = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 60px;
  margin-bottom: 50px;
  align-items: center;
  
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 30px;
  }
`;

const SearchContainer = styled.div`
  position: relative;
  max-width: 400px;
  flex: 1;
`;

const SearchInput = styled.input`
  width: 100%;
  background: rgba(255, 255, 255, 0.1);
  border: 2px solid rgba(57, 211, 83, 0.3);
  border-radius: 25px;
  padding: 15px 50px 15px 20px;
  color: #fff;
  font-size: 1rem;
  transition: all 0.3s ease;
  box-sizing: border-box;
  
  &::placeholder {
    color: #ccc;
  }
  
  &:focus {
    outline: none;
    border-color: #39d353;
    background: rgba(255, 255, 255, 0.15);
    box-shadow: 0 0 0 3px rgba(57, 211, 83, 0.1);
  }
  
  &:hover {
    border-color: rgba(57, 211, 83, 0.5);
  }
`;

const SearchIcon = styled.div`
  position: absolute;
  right: 18px;
  top: 50%;
  transform: translateY(-50%);
  color: #39d353;
  font-size: 1.1rem;
  pointer-events: none;
`;

const CategoryFilter = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  justify-content: center;
  
  @media (max-width: 768px) {
    gap: 8px;
  }
`;

const CategoryButton = styled.button`
  background: ${props => props.active ? '#39d353' : 'rgba(57, 211, 83, 0.1)'};
  color: ${props => props.active ? '#000' : '#39d353'};
  border: 2px solid #39d353;
  padding: 10px 20px;
  border-radius: 20px;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  
  &:hover {
    background: #39d353;
    color: #000;
    transform: translateY(-2px);
  }
  
  @media (max-width: 768px) {
    padding: 8px 16px;
    font-size: 0.85rem;
  }
`;

const StatsSection = styled.div`
  display: flex;
  justify-content: center;
  gap: 60px;
  margin: 60px 0;
  padding: 40px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 20px;
  backdrop-filter: blur(10px);
  
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 30px;
    text-align: center;
    margin: 40px 0;
    padding: 30px 20px;
  }
`;

const StatItem = styled.div`
  text-align: center;
`;

const StatNumber = styled.div`
  font-size: 3rem;
  font-weight: bold;
  color: #39d353;
  margin-bottom: 10px;
  
  @media (max-width: 768px) {
    font-size: 2.5rem;
  }
`;

const StatLabel = styled.div`
  font-size: 1.1rem;
  color: #ccc;
  font-weight: 500;
`;

const ProductsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 2.5rem;
  margin-top: 40px;
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 2rem;
  }
`;

const ProductCard = styled.div`
  background: rgba(255, 255, 255, 0.08);
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  transition: all 0.4s ease;
  position: relative;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  
  &:hover {
    transform: translateY(-10px);
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.4);
    background: rgba(255, 255, 255, 0.12);
  }
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    background: linear-gradient(90deg, #39d353, #4ade80);
    opacity: 0;
    transition: opacity 0.3s ease;
  }
  
  &:hover::before {
    opacity: 1;
  }
`;

const ProductImage = styled.div`
  width: 100%;
  height: 200px;
  background-image: url(${props => props.src});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  position: relative;
  
  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 60px;
    background: linear-gradient(transparent, rgba(0, 0, 0, 0.7));
  }
`;

const CategoryBadge = styled.div`
  position: absolute;
  top: 15px;
  left: 15px;
  background: rgba(57, 211, 83, 0.9);
  color: #000;
  padding: 6px 12px;
  border-radius: 15px;
  font-size: 0.8rem;
  font-weight: 600;
  text-transform: uppercase;
`;

const RatingBadge = styled.div`
  position: absolute;
  top: 15px;
  right: 15px;
  background: rgba(0, 0, 0, 0.8);
  color: #39d353;
  padding: 8px 12px;
  border-radius: 20px;
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 0.9rem;
  font-weight: bold;
  backdrop-filter: blur(10px);
`;

const CardContent = styled.div`
  padding: 25px;
`;

const ProductName = styled.h3`
  font-size: 1.4rem;
  color: #fff;
  margin: 0 0 10px 0;
  font-weight: 600;
`;

const ProductDescription = styled.p`
  color: #ccc;
  margin: 0 0 15px 0;
  font-size: 0.95rem;
  line-height: 1.5;
`;

const BenefitsList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 20px;
`;

const BenefitTag = styled.span`
  background: rgba(57, 211, 83, 0.15);
  color: #39d353;
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 0.75rem;
  font-weight: 500;
  border: 1px solid rgba(57, 211, 83, 0.3);
`;

const PriceSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
`;

const PriceContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const CurrentPrice = styled.span`
  font-size: 1.6rem;
  font-weight: bold;
  color: #39d353;
`;

const OriginalPrice = styled.span`
  font-size: 1.1rem;
  color: #888;
  text-decoration: line-through;
`;

const ReviewsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  color: #ccc;
  font-size: 0.9rem;
`;

const BuyButton = styled.button`
  background: linear-gradient(135deg, #39d353, #4ade80);
  color: #000;
  border: none;
  padding: 12px;
  border-radius: 12px;
  font-weight: bold;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.3s ease;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  
  &:hover {
    background: linear-gradient(135deg, #4ade80, #39d353);
    transform: translateY(-2px);
    box-shadow: 0 5px 15px rgba(57, 211, 83, 0.3);
  }
`;

function ShopFullPage() {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('All');
  const navigate = useNavigate();

  // Navigation functions for navbar
  const scrollToAbout = () => {
    navigate('/');
    setTimeout(() => {
      const element = document.querySelector('[data-section="services"]');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }, 100);
  };

  const scrollToTrainers = () => {
    navigate('/trainers');
  };

  const scrollToShop = () => {
    // Already on shop page, scroll to top
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const scrollToTrainingZone = () => {
    navigate('/');
    setTimeout(() => {
      const element = document.querySelector('[data-section="training-zone"]');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }, 100);
  };

  const scrollToContact = () => {
    navigate('/');
    setTimeout(() => {
      const element = document.querySelector('[data-section="contact"]');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }, 100);
  };

  // Filter products based on search term and category
  const filteredProducts = products.filter(product => {
    const matchesSearch =
      product.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      product.category.toLowerCase().includes(searchTerm.toLowerCase()) ||
      product.description.toLowerCase().includes(searchTerm.toLowerCase()) ||
      product.benefits.some(benefit => benefit.toLowerCase().includes(searchTerm.toLowerCase()));

    const matchesCategory = selectedCategory === 'All' || product.category === selectedCategory;

    return matchesSearch && matchesCategory;
  });

  const handleBuyNow = (product) => {
    console.log('Buy now:', product.name);
    // Add buy now functionality here
  };

  return (
    <PageContainer>
      <Navbar
        scrollToTrainers={scrollToTrainers}
        scrollToAbout={scrollToAbout}
        scrollToShop={scrollToShop}
        scrollToTrainingZone={scrollToTrainingZone}
        scrollToContact={scrollToContact}
      />

      <MainContent>
        <Header>
          <Title>Fitness <span style={{ color: '#39d353' }}>Shop</span></Title>
          <Subtitle>
            Premium supplements and nutrition products to fuel your fitness journey.
            Quality guaranteed, results delivered. Everything you need to achieve your fitness goals.
          </Subtitle>
        </Header>

        <FilterSection>
          <SearchContainer>
            <SearchInput
              type="text"
              placeholder="Search products, categories, or benefits..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            <SearchIcon>
              <FaSearch />
            </SearchIcon>
          </SearchContainer>

          <CategoryFilter>
            {categories.map((category) => (
              <CategoryButton
                key={category}
                active={selectedCategory === category}
                onClick={() => setSelectedCategory(category)}
              >
                {category}
              </CategoryButton>
            ))}
          </CategoryFilter>
        </FilterSection>

        <StatsSection>
          <StatItem>
            <StatNumber>{products.length}</StatNumber>
            <StatLabel>Products Available</StatLabel>
          </StatItem>
          <StatItem>
            <StatNumber>50+</StatNumber>
            <StatLabel>Premium Brands</StatLabel>
          </StatItem>
          <StatItem>
            <StatNumber>10K+</StatNumber>
            <StatLabel>Happy Customers</StatLabel>
          </StatItem>
          <StatItem>
            <StatNumber>24/7</StatNumber>
            <StatLabel>Fast Delivery</StatLabel>
          </StatItem>
        </StatsSection>

        <ProductsGrid>
          {filteredProducts.map((product) => (
            <ProductCard key={product.id}>
              <ProductImage src={product.image}>
                <CategoryBadge>{product.category}</CategoryBadge>
                <RatingBadge>
                  <FaStar />
                  {product.rating}
                </RatingBadge>
              </ProductImage>

              <CardContent>
                <ProductName>{product.name}</ProductName>
                <ProductDescription>{product.description}</ProductDescription>

                <BenefitsList>
                  {product.benefits.map((benefit, index) => (
                    <BenefitTag key={index}>
                      {benefit}
                    </BenefitTag>
                  ))}
                </BenefitsList>

                <PriceSection>
                  <PriceContainer>
                    <CurrentPrice>{product.price}</CurrentPrice>
                    <OriginalPrice>{product.originalPrice}</OriginalPrice>
                  </PriceContainer>
                  <ReviewsContainer>
                    <FaStar color="#39d353" />
                    {product.reviews} reviews
                  </ReviewsContainer>
                </PriceSection>

                <BuyButton onClick={() => handleBuyNow(product)}>
                  <FaShoppingCart />
                  Buy Now
                </BuyButton>
              </CardContent>
            </ProductCard>
          ))}
        </ProductsGrid>

        {filteredProducts.length === 0 && (
          <div style={{
            textAlign: 'center',
            padding: '60px 20px',
            color: '#ccc',
            fontSize: '1.2rem'
          }}>
            No products found matching your criteria. Try adjusting your search or filter.
          </div>
        )}
      </MainContent>

      <Footer />
    </PageContainer>
  );
}

export default ShopFullPage;
